import { WooIdWithText } from '@nosinovacao/fe-icons';
import { cn, useInMediaQuery } from '@nosinovacao/nosid-mfe-common';
import { Link } from '@tanstack/react-router';
import { type ContainerProps } from '../props';
import { NavbarContextProvider } from '../context/navbar';
import { UserSettingsSheetWoo, UserSettingsTriggerWoo } from './user-settings';
import { DesktopNavbarWoo, MobileNavbarTriggerWoo, MobileNavbarWoo } from './navbar';

export function ContainerWoo({ children, subtitle, title }: Readonly<ContainerProps>) {
  const isDesktop = useInMediaQuery('desktop-md');
  return (
    <NavbarContextProvider>
      <UserSettingsSheetWoo>
        <div
          className={cn(
            'min-h-dvh bg-nos-neutral-75',
            isDesktop ? 'grid grid-cols-[338px_1fr] ' : 'relative isolate',
          )}
        >
          {isDesktop ? (
            <DesktopNavbarWoo />
          ) : (
            <>
              <header className="sticky top-0 z-10 flex h-16 flex-nowrap items-center justify-between gap-2 overflow-hidden bg-woo-green px-4 py-3 text-nos-neutral-1000">
                <Link to="/home" className="rounded-md outline-none focus-visible:outline-woo-blue">
                  <WooIdWithText className="text-nos-neutral-1000" />
                </Link>
                <div className="flex shrink-0 items-center justify-between gap-6">
                  <UserSettingsTriggerWoo />
                  <MobileNavbarTriggerWoo />
                  <MobileNavbarWoo />
                </div>
              </header>
              <div className="absolute left-0 top-16 -z-10 h-[101px] w-full shrink-0 bg-woo-green [clip-path:_polygon(0_0,_100%_0,_100%_85%,_0%_100%)]" />
            </>
          )}

          <div
            className={cn(
              'relative',
              isDesktop ? 'grid auto-rows-max px-6 pb-10' : 'px-4 pb-6 pt-4 tablet:px-10',
            )}
          >
            <ContainerPreContent subtitle={subtitle} title={title} />
            {children}
          </div>
        </div>
      </UserSettingsSheetWoo>
    </NavbarContextProvider>
  );
}

function ContainerPreContent({ subtitle, title }: Readonly<{ title?: string; subtitle?: string }>) {
  const isDesktop = useInMediaQuery('desktop-md');
  if (isDesktop)
    return (
      <>
        <div className="sticky top-0 z-10 grid grid-cols-[1fr_auto] gap-x-10 bg-nos-neutral-75 pb-6 pt-10">
          {title ? (
            <h1 className="font-light text-nos-neutral-900 font-title-h2">{title}</h1>
          ) : (
            <div></div>
          )}
          <UserSettingsTriggerWoo />
        </div>
        {subtitle ? (
          <h2 className="mb-6 font-light text-nos-neutral-500 font-text-p1">{subtitle}</h2>
        ) : null}
      </>
    );

  if (!subtitle) return null;

  return <h1 className="mb-2 font-light text-nos-neutral-900 font-text-p1">{subtitle}</h1>;
}
